var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFransavi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.6,28.9c-0.2,0-0.4-0.1-0.5-0.3l-0.6-1.7c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l0.6,1.7 c0.1,0.3-0.1,0.5-0.3,0.6L19.6,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,24.9c-0.2,0-0.4-0.1-0.5-0.3l-1.1-3.4c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l1.1,3.4 c0.1,0.3-0.1,0.5-0.3,0.6L18.3,24.9z M16.3,19c-0.2,0-0.4-0.1-0.5-0.3l-1.1-3.4c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3 l1.1,3.4c0.1,0.3-0.1,0.5-0.3,0.6L16.3,19z M14.4,13c-0.2,0-0.4-0.1-0.5-0.3l-1.1-3.4c-0.1-0.3,0.1-0.5,0.3-0.6 c0.3-0.1,0.5,0.1,0.6,0.3l1.1,3.4c0.1,0.3-0.1,0.5-0.3,0.6L14.4,13z M12.4,7.1c-0.2,0-0.4-0.1-0.5-0.3L11,4 c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l0.9,2.8C13,6.7,12.8,7,12.6,7.1L12.4,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1,3.1c-0.2,0-0.4-0.1-0.5-0.3l-0.6-1.7c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3l0.6,1.7 c0.1,0.3-0.1,0.5-0.3,0.6L11.1,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,30l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l0.9-2.8c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6l-0.9,2.8 C1.5,29.9,1.3,30,1.1,30z M2.9,24.4l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.2-3.7c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6 l-1.2,3.7C3.3,24.3,3.1,24.4,2.9,24.4z M5,18l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.2-3.7c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6l-1.2,3.7C5.4,17.9,5.2,18,5,18z M7.2,11.6l-0.2,0c-0.3-0.1-0.4-0.4-0.3-0.6l1.2-3.7C8,7,8.3,6.8,8.6,6.9 C8.8,7,8.9,7.3,8.9,7.5l-1.2,3.7C7.6,11.4,7.4,11.6,7.2,11.6z M9.3,5.1l-0.2,0C8.9,5,8.8,4.7,8.9,4.5l1.2-3.7 c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6L9.8,4.8C9.7,5,9.5,5.1,9.3,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,15.6c-0.1,0-0.2,0-0.3-0.1L0.6,1.3C0.4,1.1,0.4,0.8,0.6,0.6C0.7,0.4,1,0.4,1.2,0.6l17.1,14.2c0.2,0.2,0.2,0.5,0.1,0.7 C18.3,15.6,18.2,15.6,18,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9,29c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l17.1-13.3c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.2,0.1,0.5-0.1,0.7 L1.2,28.9C1.1,29,1,29,0.9,29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,29.7H0V0h30V29.7z M1,28.7H29V1H1V28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6,26.3H3.5V3.1h14.1V26.3z M4.5,25.4h12.2V4.1H4.5V25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,26.5h-4.5V3.1h4.5V26.5z M23.8,25.6h2.6V4.1h-2.6V25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,29.4c-0.3,0-0.5-0.2-0.5-0.5v-28c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28C20.4,29.2,20.2,29.4,19.9,29.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.7,
    y: 11.2,
    width: 3.5,
    height: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFransavi);
export default __webpack_public_path__ + "static/media/fransavi.bad467a297ace49a4cc30ee9201d816e.svg";
export { ForwardRef as ReactComponent };